module.exports = __webpack_public_path__ + "static/media/details.de55c10e.png";